module.exports = __webpack_public_path__ + "static/img/demo.26a9c3cd.png";